import type { NestTestResultError } from "src/api/interfaces/nest/history";
import type {
  ColumnDefinition,
  DataTableDefinition,
} from "src/components/DataTable/DataTableDefinition";
import { DataTableEspecialProperties } from "src/components/DataTable/DataTableDefinition";
import NestErrorCodeCell from "./NestErrorCodeCell";
import NestErrorElementCell from "./NestErrorElementCell";
import NestErrorLineCell from "./NestErrorLineCell";
import NestErrorMessageCell from "./NestErrorMessageCell";
import NestErrorSeverityCell from "./NestErrorSeverityCell";
import NestErrorSeveritySortHeader from "./NestErrorSeveritySortHeader";

type SortDirection = "asc" | "desc" | false;

interface BuildTableDefinitionOptions {
  sortDirection: SortDirection;
  onToggleSort: () => void;
}

export const buildNestErrorTableDefinition = ({
  sortDirection,
  onToggleSort,
}: BuildTableDefinitionOptions): DataTableDefinition<NestTestResultError> => {
  const columnsDefinition: ColumnDefinition[] = [
    {
      label: "aic_nest_history_error_line",
      property: "line",
      ChildComponent: NestErrorLineCell,
      childComponentOnly: true,
    },
    {
      label: "aic_nest_history_error_message",
      property: "message",
      ChildComponent: NestErrorMessageCell,
      childComponentOnly: true,
    },
    {
      label: "aic_nest_history_error_error",
      property: "error",
      ChildComponent: NestErrorCodeCell,
      childComponentOnly: true,
    },
    {
      label: "",
      property: "severity",
      ChildComponent: NestErrorSeverityCell,
      childComponentOnly: true,
      HeaderComponent: NestErrorSeveritySortHeader,
      headerComponentProps: { sortDirection, onToggleSort },
    },
    {
      label: "aic_nest_history_error_element",
      property: "element",
      ChildComponent: NestErrorElementCell,
      childComponentOnly: true,
    },
    {
      label: "",
      property: DataTableEspecialProperties.ICON.valueOf(),
    },
  ];

  return { columnsDefinition };
};
